module.exports = { tints: require("minecraft-data/minecraft-data/data/pc/1.16.2/tints.json") }